<app-sky-transition
  *ngIf="brand.showMascot && showResultTransition"
  eyebrow="Your result"
  [context]="skyCoachContext()"
  (closed)="closeResultTransition()" />

<div class="test-report-page">
  <a routerLink="/dashboard" class="back-link">
    <i class="bi bi-arrow-left"></i> Back to Dashboard
  </a>

  <h1 class="page-title">Test report</h1>

  <div class="panel test-report-panel" *ngIf="report">
    <div class="report-header">
      <div class="report-header-copy">
        <h2 class="report-test-title">{{ report.testTitle || 'Session summary' }}</h2>
        <p class="report-meta text-muted">
          {{ report.questions.length }} questions
          <span aria-hidden="true">·</span>
          {{ report.finishedAt | date:'MMM d, y, h:mm':'UTC' }}
          <span aria-hidden="true">·</span>
          {{ report.timeSpent | date:'m:ss':'UTC' }}
        </p>
        <button *ngIf="isExamMode() && testPassed()" type="button" class="btn btn-success btn-sm disabled">Exam passed</button>
        <button *ngIf="isExamMode() && !testPassed()" type="button" class="btn btn-danger btn-sm disabled">Exam failed</button>
      </div>
      <div class="report-header-score">
        <div class="report-score-summary">
          <span class="report-score-pill report-score-correct">{{ correctCount() }} correct</span>
          <span class="report-score-pill report-score-wrong">{{ wrongCount() }} wrong</span>
          <span class="report-score-pill report-score-unanswered" *ngIf="unansweredCount() > 0">
            {{ unansweredCount() }} unanswered
          </span>
        </div>
        <div class="report-header-chart" id="chart" #chart aria-label="Score chart">
          <apx-chart
            [colors]="['#5bc394', '#E91E63', '#707070']"
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [labels]="chartOptions.labels"
            [legend]="chartOptions.legend"
            [dataLabels]="chartOptions.dataLabels"
            [plotOptions]="chartOptions.plotOptions"
            [responsive]="chartOptions.responsive"
          ></apx-chart>
        </div>
      </div>
    </div>

    <div class="result-feedback-card" *ngIf="resultFeedbackReady">
      <app-sky-coach-panel *ngIf="brand.showMascot" layout="result" [context]="skyCoachContext()">
        <div
          skyCopyExtra
          class="next-session-card"
          *ngIf="resultFeedback?.nextRecommendation as recommendation">
          <div>
            <span class="result-feedback-kicker">Next session</span>
            <h4>{{ recommendation.ctaLabel }}</h4>
          </div>
          <button type="button" class="btn btn-primary" (click)="openRecommendedSession()">
            {{ recommendedActionLabel() }}
          </button>
        </div>
      </app-sky-coach-panel>
      <div
        class="next-session-card"
        *ngIf="!brand.showMascot && resultFeedback?.nextRecommendation as recommendation">
        <div>
          <span class="result-feedback-kicker">Next session</span>
          <h4>{{ recommendation.ctaLabel }}</h4>
        </div>
        <button type="button" class="btn btn-primary" (click)="openRecommendedSession()">
          {{ recommendedActionLabel() }}
        </button>
      </div>

      <ng-container *ngIf="resultFeedback">
        <div class="review-next" *ngIf="resultFeedback.readiness || resultFeedback.weakTopics?.length">
          <span class="result-feedback-kicker">Recommended</span>
          <p class="review-context" *ngIf="resultFeedback.readiness">
            {{ resultFeedback.readiness.subjectName || 'Subject progress' }}
            <span aria-hidden="true">·</span>
            {{ resultFeedback.readiness.questionsSeen || 0 }} / {{ resultFeedback.readiness.questionsTotal || 0 }} seen
          </p>
          <ul *ngIf="resultFeedback.weakTopics?.length">
            <li *ngFor="let topic of resultFeedback.weakTopics?.slice(0, 3)">
              {{ topic.topicName }} <span>({{ topic.wrongCount }} wrong)</span>
            </li>
          </ul>
          <details class="more-topics" *ngIf="(resultFeedback.weakTopics?.length || 0) > 3">
            <summary>
              View {{ (resultFeedback.weakTopics?.length || 0) - 3 }} more
              topic{{ (resultFeedback.weakTopics?.length || 0) - 3 === 1 ? '' : 's' }}
            </summary>
            <ul>
              <li *ngFor="let topic of resultFeedback.weakTopics?.slice(3)">
                {{ topic.topicName }} <span>({{ topic.wrongCount }} wrong)</span>
              </li>
            </ul>
          </details>
        </div>
      </ng-container>
    </div>

    <div class="report-answer-filters">
      <div class="form-check form-switch d-inline-block me-4">
        <input class="form-check-input" type="checkbox" id="showCorrect" [(ngModel)]="showCorrectAnswers">
        <label class="form-check-label" for="showCorrect">
          <i class="bi bi-check-circle-fill text-success"></i> Show correct answers
        </label>
      </div>
      <div class="form-check form-switch d-inline-block">
        <input class="form-check-input" type="checkbox" id="showWrong" [(ngModel)]="showWrongAnswers">
        <label class="form-check-label" for="showWrong">
          <i class="bi bi-x-circle-fill text-danger"></i> Show wrong answers
        </label>
      </div>
    </div>

    <div *ngIf="getFilteredQuestions().length > 0" class="report-questions">
      <ng-template ngFor let-question [ngForOf]="getFilteredQuestions()" let-i="index">
        <div [ngClass]="{
          'alert-success': isCorrect(question),
          'alert-danger': !isCorrect(question)
        }" class="alert p-2 mb-2" role="alert">
          <div class="d-flex align-items-start">
            <div class="me-2">
              <i *ngIf="isCorrect(question)" class="bi bi-check-circle-fill text-success fs-5"></i>
              <i *ngIf="!isCorrect(question)" class="bi bi-x-circle-fill text-danger fs-5"></i>
            </div>
            <div class="flex-grow-1">
              <h6 class="alert-heading mb-2" [innerHTML]="sanitizeHtml(question.title)"></h6>
              <ng-template ngFor let-answer [ngForOf]="question.answers" let-j="index">
                <small *ngIf="answer.isCorrect" class="d-block mb-1">
                  <strong>Correct answer:</strong> <span [innerHTML]="sanitizeHtml(answer.label)"></span>
                </small>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div *ngIf="getFilteredQuestions().length === 0 && countQuestions() > 0" class="alert alert-info text-center" role="alert">
      <i class="bi bi-info-circle"></i> No questions match the selected filters.
    </div>

    <div *ngIf="countWrong() == 0 && countUnanswered() == 0 && countQuestions() > 0" class="alert alert-success text-center" role="alert">
      <i class="bi bi-check-circle-fill"></i> All your answers were correct!
    </div>
  </div>

  <div class="report-actions" aria-label="More actions">
    <span class="report-actions-label">More actions</span>
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="startAnotherTest()"
      [disabled]="recreateLoading || !reportId">
      <span *ngIf="recreateLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Repeat this setup
    </button>
    <a routerLink="/saved-tests" class="btn btn-outline-secondary">Saved Tests</a>
  </div>
</div>
